import React from 'react';

const Hero = () => {
    const scrollToProducts = () => {
        document.getElementById('products')?.scrollIntoView({ behavior: 'smooth' });
    };

    return (
        <section id="home" className="relative h-screen min-h-[800px] flex items-center justify-center overflow-hidden pt-20">
            {/* STATIC Background Image */}
            <div
                className="absolute inset-0 z-0 bg-cover bg-center bg-no-repeat"
                style={{
                    backgroundImage: `url('${process.env.PUBLIC_URL}/images/hero_background_1768733796258.png')`
                }}
            />

            {/* Clearer Gradient Overlay */}
            <div className="absolute inset-0 z-0 bg-gradient-to-b from-dark-900/80 via-dark-900/40 to-dark-900/90" />

            {/* Main Content */}
            <div className="container mx-auto px-4 relative z-10 text-center flex flex-col items-center justify-center h-full">

                {/* Badge */}
                <div className="inline-block mb-6 px-4 py-1 rounded-full border border-royal-500/30 bg-dark-900/60 backdrop-blur-sm">
                    <span className="text-royal-500 text-xs font-bold tracking-[0.2em] uppercase">
                        Premium Engineering
                    </span>
                </div>

                {/* Main Title: MD.SAMSUDDIN */}
                <h1 className="font-display font-black leading-tight mb-2 drop-shadow-2xl">
                    <span className="block text-transparent bg-clip-text bg-gradient-to-r from-royal-300 via-white to-royal-100 text-4xl sm:text-5xl md:text-7xl lg:text-8xl w-full">
                        MD.SAMSUDDIN
                    </span>
                </h1>

                {/* Subtitle: SHUTTER & ENGG. WORKS */}
                <h2 className="font-display font-bold text-royal-500 tracking-widest text-xl sm:text-2xl md:text-4xl uppercase mb-6 drop-shadow-lg">
                    SHUTTER & ENGG. WORKS
                </h2>

                {/* Description: MFG Details */}
                <p className="font-sans text-base sm:text-xl text-white max-w-3xl mx-auto mb-8 leading-relaxed font-light border-t border-b border-white/10 py-4">
                    MFG: Rolling Shutter, M.S. Door, Window Collapsible Gates & Grill.
                </p>



                {/* Call to Action Buttons */}
                <div className="flex flex-col sm:flex-row gap-4 justify-center items-center w-full max-w-md mx-auto">
                    <button onClick={scrollToProducts} className="w-full sm:w-auto btn-royal text-base md:text-lg px-8 py-3 tracking-wider uppercase shadow-lg shadow-royal-500/20 hover:shadow-glow-orange whitespace-nowrap">
                        View Products
                    </button>
                    <a
                        href="tel:9007735583"
                        className="w-full sm:w-auto bg-transparent border border-white/30 text-white text-base md:text-lg px-8 py-3 tracking-wider uppercase hover:bg-white hover:text-dark-900 transition-all duration-300 font-bold backdrop-blur-sm whitespace-nowrap flex justify-center items-center gap-2"
                    >
                        <span>📞</span> Call Now
                    </a>
                </div>
            </div>
        </section>
    );
};

export default Hero;
